<template>
  <p
    :class="[
      !bold && !italic && !underline && 'text',
      bold && 'font-bold',
      italic && 'italic',
      underline && 'underline',
    ]"
  >
    {{ text }}<slot></slot>
  </p>
</template>

<script setup>
defineProps({
  text: {
    type: String,
  },
  bold: {
    type: Boolean,
  },
  italic: {
    type: Boolean,
  },
  underline: {
    type: Boolean,
  },
});
</script>

<style></style>
